import { ImageVM } from '@porterin/booking-flow/src/auth/view-model/auth-content/AuthContentVM';
import { isDesktop } from '@porterin/lead-flow/src/components/FareEstimateHelper';
import Image from 'next/image';

import { AuthModalVariant } from '..';

export interface AuthBannerProps {
  banner: ImageVM;
  // Only rendered when show_mobile_banner is true (e.g. OTP hides it), so
  // callers that never show it need not supply one.
  mobileBanner?: ImageVM;
  show_mobile_banner?: boolean;
  auth_state: AuthModalVariant;
}

const AuthBanner: React.FC<AuthBannerProps> = ({
  banner,
  mobileBanner,
  show_mobile_banner = true,
  auth_state,
}) => {
  const mobileHeight =
    auth_state == 'login' ? 'min-h-[24rem]' : 'min-h-[15.2rem]';

  if (isDesktop()) {
    return (
      <div className="relative min-w-[38.6rem] h-full overflow-visible">
        <Image
          src={banner.path}
          alt={banner.altText}
          layout="fill"
          className="max-w-full object-cover"
        />
      </div>
    );
  }

  if (!show_mobile_banner || !mobileBanner) {
    return null;
  }

  return (
    <div className={`relative w-full ${mobileHeight}`}>
      <Image
        src={mobileBanner.path}
        alt={mobileBanner.altText}
        fill={true}
        className="object-contain"
      />
    </div>
  );
};

export default AuthBanner;
